<app-button-close (click)="navigateBackToList()"></app-button-close>
<div [kalLoading]="loading$ | async">
    <div *ngIf="allocation">
        <kal-card>

            <kal-card-header>
                <kal-card-on-title *ngIf="!!allocation.EnveloppeModel">
                    Enveloppe {{allocation.EnveloppeModel.Libelle}} <span *ngIf="isEnvelopeArchived"> - Enveloppe archivée</span>
                </kal-card-on-title>
                <kal-card-title>{{allocation.Libelle}}</kal-card-title>

                <p *ngIf="allocation.AttribTgExec && !!allocation.DateExec">
                    <ng-container
                        *ngIf="!allocation.DateDernierMAJ || allocation.DateExec === allocation.DateDernierMAJ; else multipleExecution">
                        {{allocationService.type | i18nSelect: allocationService.executedI18n }} le {{allocation.DateExec | date: 'dd/MM/yyyy'}}
                    </ng-container>
                    <ng-template #multipleExecution>
                        Première exécution le {{allocation.DateExec | date: 'dd/MM/yyyy'}}
                    </ng-template>
                </p>
            </kal-card-header>

        </kal-card>

        <kal-tab-group [formControl]="selectedTabControl">

            <kal-tab>

                <!-- Information -->
                <ng-template kalTabLabel>
                    Informations
                </ng-template>

                <ng-template kalTabContent>
                    <app-shared-allocation-informations>
                    </app-shared-allocation-informations>

                    <ng-container *ngTemplateOutlet="tabFooter"></ng-container>
                </ng-template>

            </kal-tab>

            <kal-tab>
                <!-- Pour qui -->
                <ng-template kalTabLabel>
                    Pour qui
                </ng-template>

                <ng-template kalTabContent>

                    <app-shared-allocation-accessibility-detail [allocation]="allocation"
                                                                *ngIf="!advancedAccessibilityRule else advancedAccessibilityRuleTemplate">
                    </app-shared-allocation-accessibility-detail>

                    <ng-template #advancedAccessibilityRuleTemplate>

                        <app-shared-advanced-rule-detail [rule]="advancedAccessibilityRule">
                            <a (click)="openAdvancedRuleDetailDialog(advancedAccessibilityRule)" class="gup-O-link -secondary">Voir les critères avancés de la règle</a>
                        </app-shared-advanced-rule-detail>

                    </ng-template>

                    <ng-container *ngTemplateOutlet="tabFooter"></ng-container>
                </ng-template>
            </kal-tab>

            <kal-tab>
                <!-- Combien -->
                <ng-template kalTabLabel>
                    Combien
                </ng-template>

                <ng-template kalTabContent>

                    <app-shared-allocation-detail-envelope
                        *ngIf="!advancedSubventionRule else advancedSubventionRuleTemplate"
                        [allocation]="allocation"
                        [type]="type">
                    </app-shared-allocation-detail-envelope>

                    <ng-template #advancedSubventionRuleTemplate>

                        <app-shared-advanced-rule-detail [rule]="advancedSubventionRule">
                            <a (click)="openAdvancedRuleDetailDialog(advancedSubventionRule)" class="gup-O-link -secondary">Voir les critères avancés de la règle</a>
                        </app-shared-advanced-rule-detail>

                    </ng-template>

                    <ng-container *ngTemplateOutlet="tabFooter"></ng-container>
                </ng-template>
            </kal-tab>

            <kal-tab *ngIf="allocation.DateExec && !isVirtualWallet" label="Rapport d'attribution">
                <ng-template kalTabContent>
                    <ng-content select="[report]">
                    </ng-content>
                </ng-template>

            </kal-tab>

        </kal-tab-group>

    </div>

</div>

<ng-template #tabFooter>
    <div class="gup-C-validationArea gup-O-list">

        <div *ngIf="canExecute" class="gup-O-list__item">
            <kal-button (click)="execute()"
                        kalTheme="primary">
                {{allocationService.executeLabel}}
            </kal-button>
        </div>

        <div *ngIf="canCancelExecution" class="gup-O-list__item">
            <kal-button (appConfirm)="cancelExecution()"
                        appConfirmBody="Souhaitez-vous annuler l'exécution de l'attribution &quot;{{allocation.Libelle}}&quot; ?"
                        appConfirmCancel="Fermer"
                        appConfirmSubmit="Annuler l'exécution"
                        appConfirmTitle="Annulation de l'exécution de l'attribution"
                        kalTheme="secondary">
                {{allocationService.cancelExecutionLabel}}
            </kal-button>
        </div>

        <div *ngIf="canSettle" class="gup-O-list__item">
            <kal-button (click)="settle()"
                        kalTheme="tertiary">
                Solder
            </kal-button>
        </div>

        <ng-container *ngIf="!(canExecute && canCancelExecution && canSettle) else sortMenuTemplate">

            <div *ngIf="canEdit" class="gup-O-list__item">
                <kal-button (click)="edit()"
                            kalTheme="tertiary">
                    Modifier
                </kal-button>
            </div>

            <div class="gup-O-list__item">
                <kal-button (click)="duplicate()"
                            kalTheme="tertiary">
                    Dupliquer
                </kal-button>
            </div>

            <div *ngIf="canDelete" class="gup-O-list__item">
                <kal-button (appConfirm)="delete()"
                            appConfirmBody="Souhaitez-vous supprimer l'attribution &quot;{{allocation.Libelle }}&quot; ?"
                            appConfirmSubmit="Supprimer"
                            appConfirmTitle="Supprimer l'attribution"
                            kalTheme="tertiary">
                    Supprimer
                </kal-button>
            </div>

            <div *ngIf="canArchive" class="gup-O-list__item">
                <kal-button (click)="archive()"
                            kalTheme="tertiary">
                    Archiver
                </kal-button>
            </div>

        </ng-container>

        <ng-template #sortMenuTemplate>

            <kal-button (click)="stopPropagation($event)"
                        [kalMenuTriggerFor]="actionsMenu"
                        kalTheme="tertiary">
                <kal-icon>more_horiz</kal-icon>
            </kal-button>

            <kal-menu #actionsMenu>
                <kal-option (selectionChange)="edit()">
                    Modifier
                </kal-option>

                <kal-option (selectionChange)="duplicate()">
                    Dupliquer
                </kal-option>

                <kal-option (selectionChange)="archive()" *ngIf="canArchive">
                    Archiver
                </kal-option>
            </kal-menu>

        </ng-template>

    </div>

</ng-template>
